import React from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  Stack,
  IconButton,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { useNavigate } from "react-router-dom";

const brown = "#6b4f3b";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: "#0f0f0f", color: "white", py: 10 }}>
      <Container>
        {/* ================= FLEX LAYOUT ================= */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 6,
            justifyContent: "space-between",
          }}
        >
          {/* ================= BRAND ================= */}
          <Box sx={{ flex: "1 1 300px" }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Crush Café
            </Typography>

            <Typography sx={{ opacity: 0.6, mb: 3, lineHeight: 1.7 }}>
              Caffè accogliente, buone vibrazioni e uno spazio per lavorare o
              incontrare amici. Dall’espresso mattutino agli aperitivi serali,
              rendiamo ogni visita calda e personale.
            </Typography>

            <Stack direction="row" spacing={1}>
              <IconButton
                href="https://wa.me/393755752929"
                target="_blank"
                sx={{ color: "white" }}
              >
                <WhatsAppIcon />
              </IconButton>

              <IconButton
                href="mailto:caffetteriapisabar@gmail.com"
                sx={{ color: "white" }}
              >
                <EmailIcon />
              </IconButton>
            </Stack>
          </Box>

          {/* ================= NAVIGATION ================= */}
          <Box sx={{ flex: "1 1 180px" }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Menu
            </Typography>

            <Stack spacing={1}>
              <Link
                color="inherit"
                underline="hover"
                onClick={() => navigate("/")}
              >
                Home
              </Link>

              <Link
                color="inherit"
                underline="hover"
                onClick={() => navigate("/crush-coffee")}
              >
                Menu
              </Link>

              <Link
                color="inherit"
                underline="hover"
                onClick={() => navigate("/about")}
              >
                About Us
              </Link>

              <Link
                color="inherit"
                underline="hover"
                onClick={() => navigate("/contact")}
              >
                Contact
              </Link>
            </Stack>
          </Box>

          {/* ================= CONTACT ================= */}
          <Box sx={{ flex: "1 1 240px" }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Contact
            </Typography>

            <Stack spacing={2}>
              <Typography sx={{ opacity: 0.7 }}>
                Via Bar Pisa da Ale, Via Pisa, <br />
                Treviso, Italia
              </Typography>

              <Stack direction="row" spacing={1} alignItems="center">
                <PhoneIcon fontSize="small" />
                <Link
                  href="tel:+393755752929"
                  color="inherit"
                  underline="hover"
                >
                  +39 375 575 2929
                </Link>
              </Stack>

              <Stack direction="row" spacing={1} alignItems="center">
                <EmailIcon fontSize="small" />
                <Link
                  href="mailto:caffetteriapisabar@gmail.com"
                  color="inherit"
                  underline="hover"
                >
                  caffetteriapisabar@gmail.com
                </Link>
              </Stack>
            </Stack>
          </Box>
        </Box>

        {/* ================= COPYRIGHT ================= */}
        <Box
          sx={{
            borderTop: "1px solid rgba(255,255,255,0.1)",
            mt: 6,
            pt: 4,
            textAlign: "center",
            opacity: 0.5,
            fontSize: 14,
          }}
        >
          © {new Date().getFullYear()} Crush Café — All rights reserved
        </Box>
      </Container>
    </Box>
  );
}
